// Bibliotecas do framework
import React from "react";
import { Link, useHistory } from "react-router-dom";

// Ícones
import { IoMdArrowRoundBack } from "react-icons/io";

// Ilustrações
import img1 from "../../../assets/materiais/criacao-elementos-img-01.svg";
import img2 from "../../../assets/materiais/criacao-elementos-img-02.svg";
import img3 from "../../../assets/materiais/criacao-elementos-img-03.svg";
import img4 from "../../../assets/materiais/criacao-elementos-img-04.svg";

// Exibição de vídeo
import ReactPlayer from "react-player";

// Barra superior
import Header from "../../Header";

export default function CriacaoElementos() {
    // Define a navegação
    const nav = useHistory();
    function back() {
        nav.goBack();
    }

    return (
        <div className="section">
            <Header />

            <div className="content">
                <div className="container">

                    <div className="linha-titulo">
                        <h3>O Início dos Elementos</h3>

                        <div className="botao-icone" onClick={back}>
                            <IoMdArrowRoundBack size={20} />
                            <span>Voltar</span>
                        </div>
                    </div>

                    <div className="linha-nivel">
                        <span className="nivel"><strong>Nível</strong>: Introdutório</span>
                    </div>

                    <div className="section">
                        <p>Os elementos são criados a partir da explosão de estrelas. Acha coisa de ficção científica? Calma, vamos para o início do universo para começar a contar toda essa história cósmica.</p>

                        <p>Partindo da teoria do Big Bang, alguma coisa originou o famoso evento. O que foi que proporcionou essa origem? Bom, não sabemos, mas vamos em frente. Depois que ocorre o evento, o universo era uma grande nuvem de partículas, que estavam extremamente quentes (e muito aceleradas).</p>

                        <div className="ilustracao">
                            <img src={img1} alt="Do Big Bang para a nuvem de partículas"/>
                        </div>

                        <p>Com o passar do tempo, as partículas foram esfriando e assim elas puderam se combinar. Nascem então os primeiros átomos, os dos elementos Hidrogênio (H) e o Hélio (He).</p>

                        <p>Quando os primeiros átomos são formados, a temperatura ainda era muito alta e os átomos de Hidrogênio começam a se agrupar em grandes aglomerados, formando as estrelas.</p>

                        <p>Dentro das estrelas, os átomos de hidrogênio colidem e promovem reações nucleares de fusão. Em outras palavras, dois átomos de Hidrogênio de fundem e originam um átomo de Hélio. Tal processo libera uma grande quantidade de energia.</p>

                        <div className="ilustracao">
                            <img src={img2} alt="Reações de fusão em uma estrela"/>
                        </div>

                        <div className="box">
                            <p>Vamos parar um pouco o fluxo da história e pensar no sol. O sol é uma estrela, que fornece energia para a Terra a partir de ondas de radiação. Toda a energia que o sol emana é originada pelos processos de fusão de átomos de hidrogênio dentro dele.</p>
                        </div>

                        <p>Para utilizar uma expressão de impacto, podemos falar que as estrelas são gigantescas bombas nucleares. Para nossa sorte, elas estão muito distante da gente, então tudo tranquilo por enquanto.</p>

                        <p>Ok, vamos voltar para a nossa linha do tempo da criação do universo. Paramos na formação das primeiras estrelas. Acontece que em determinado momento as estrelas se tornam instáveis, ou seja, começam a ter o equilíbrio perturbado. Podemos dizer que o “combustível acaba”.</p>

                        <p>Quando uma estrela chega ao fim do seu combustível, ocorre o fim da sua vida e ela explode. No processo de explosão de uma estrela ocorrem reações nucleares diversas, que são responsáveis por criar os outros elementos químicos que conhecemos. Em especial, a explosão das estrelas gera o Ferro (Fe).</p>

                        <div className="ilustracao">
                            <img src={img3} alt="Explosão de estrela e criação de elementos"/>
                        </div>

                        <p>Da morte das estrelas, nascem todos os elementos químicos. Poético, não é? E essa é uma das mais fortes teorias que temos para explicar a criação dos elementos químicos.</p>

                        <div className="box">
                            <p>Pausa para mais um comentário filosófico. Você já escutou a expressão de que nós, seres humanos, não passamos de poeira estelar? Toda a matéria ao nosso redor, inclusive a que compõe o nosso corpo, é feita de átomos. Sabendo que os átomos foram criados da explosão de estrelas, faz sentido dizer que somos poeira estelar. Concorda?</p>
                        </div>

                        <p>Continuemos com nossa linha do tempo. O espaço temporal entre o nascimento e a morte de uma estrela é muito longo, mas muito longo mesmo. Ao longo de toda a existência do universo, estrelas nasceram e morreram. Com a repetição desse processo, os elementos foram se espalhando pelo universo até que se formou toda a matéria que conhecemos hoje.</p>

                        <p>Bom, para terminar, vamos para uma breve revisão. No início, algo deu origem ao que chamamos de Big Bang. Logo depois, partículas altamente aceleradas formavam o universo, em uma espécie de nuvem de partículas.</p>

                        <p>Com o passar do tempo, o universo esfriou e as partículas se juntaram, formando os primeiros átomos (H e He). Os átomos de Hidrogênio se juntaram em estrelas, que ao morrerem (explodirem) formam os outros elementos químicos (em especial o Fe).</p>

                        <p>Estrelas nascendo e morrendo durante muito tempo dão origem a todos os elementos químicos que conhecemos. Assim, surge a matéria e, bom, a partir disso a história é outra.</p>

                        <div className="ilustracao">
                            <img src={img4} alt="Esquema do Big Bang até os elementos químicos"/>
                        </div>

                        <p>Chegamos ao fim. Espero que tenha gostado dessa nossa pequena viagem pela criação do universo e dos elementos químicos. Nos vemos por ai em outro lugar do Priore. Até a próxima.</p>
                    </div>

                    <div className="section">

                        <h4>Indicações Extras</h4>
                        <p>Se quiser saber um pouco mais sobre a teoria do Big Bang, recomendo esse vídeo produzido pelo físico Pedro Loos. Tudo bem que ele tenta fazer um tipo meio "soturno" nos vídeos, mas o conteúdo é bem legal.</p>

                        <div className="video">
                            <ReactPlayer width="100%" height="100%" url="https://youtu.be/nNAuuTIf3LE" />
                        </div>

                        <h4>Classificação Segundo a BNCC</h4>
                        <p>Competência: "Analisar e utilizar interpretações sobre a dinâmica da Vida, da Terra e do Cosmos para elaborar argumentos, realizar previsões sobre o funcinamento e a evolução dos seres vivos e do Universo, e fundamentar e defender decisões éticas e resposáveis."</p>
                        <p>Habilidade (EM13CNT209): "Analisar a evolução estelar associando-a aos modelos de origem e distribuição dos elementos químicos no Universo, compreendendo suas relações com as condições necessárias ao surgimento de sistemas solares e planetários, usa estruturas e composições e as possibilidades de existência de vida, utilizando representações e simulações, com ou sem o uso de dispositivos e aplicativos digitais."</p>

                        <h4>Informações Complementares</h4>
                        <p>
                            Para produzir este texto, retirei ideias de alguns materiais que li pela vida. A citar:
                            <br />
                            <strong>Teoria Quântica da Gravitação: Cordas e Teoria M</strong>, artigo publicado na Revista Brasileira de Ensino de Física em 2005, de autoria de Elcio Abdalla.
                            <br />
                            <strong>Química: A Ciência Central</strong>, livro publicado pela Editora Pearson em 2015, de autoria de Theodore L. Brown e colaboradores.
                            <br />
                            <strong>Química</strong>, livro publicado pela editora AMGH em 2013, de autoria de Raymond Chang e Kenneth A. Goldsby.
                        </p>

                    </div>

                </div>
            </div>

        </div>
    );
}